/**
 * Detects whether a given text is primarily Burmese or English.
 * 
 * @param text The string to evaluate
 * @returns 'burmese' | 'english' | 'unknown'
 */
export const detectLanguage = (text: string): 'burmese' | 'english' | 'unknown' => {
    if (!text || !text.trim()) return 'unknown';

    // The Unicode block for standard Myanmar (Burmese) script is \u1000 to \u109F
    const burmeseRegex = /[\u1000-\u109F]/;
    
    // Basic Latin block for English alphabets
    const englishRegex = /[a-zA-Z]/;

    // We check Burmese first. If a string has both (e.g., "Mingalarbar မင်္ဂလာပါ"), 
    // it usually means it's a Burmese context or translation.
    if (burmeseRegex.test(text)) {
        return 'burmese';
    }

    if (englishRegex.test(text)) {
        return 'english';
    }

    // Returns unknown if it only contains numbers, emojis, or punctuation
    return 'unknown';
};

/**
 * Checks if the given string contains Burmese (Myanmar) script characters.
 */
export const isBurmese = (text: string): boolean => {
    if (!text) return false;
    return /[\u1000-\u109F]/.test(text);
};

/**
 * Checks if the given string contains English (Basic Latin) alphabet characters.
 */
export const isEnglish = (text: string): boolean => {
    if (!text) return false;
    return /[a-zA-Z]/.test(text);
};
